
import {formatCoordinatesLV03, formatCoordinatesWGS84Decimal, LV03coordinates, LV03toWGS84} from "@/util";
import {allUserGrids} from "@/user_grid";

export default {
  name: "MapPopupPointInfo",
  methods: {
    LV03toWGS84,
    formatCoordinatesWGS84Decimal,
    formatCoordinatesLV03,
    getUserGridIdentifiers() {
      const result: [number, string, string][] = [];
      allUserGrids.forEach(grid => {
        const idx = grid.coordsToIndex(this.coordinates);
        if (idx != null) {
          result.push([grid.id, grid.name, grid.indexToIdentifier(idx)]);
        }
      });
      return result;
    }
  },
  props: {
    title: String,
    coordinates: {
      type: Object as () => LV03coordinates,
    },
  },
}
